import React, { useEffect } from "react";
import { FloatLabelFormattedInput } from "../../Utils/CustomComponent";

const UsePattern = ({
  title,
  type,
  field,
  register,
  watch,
  error,
  disable,
  pattern = "",
  setValue,
}) => {
  useEffect(() => {
    register("unmaskedTIN");
  }, [register]);

  return (
    <FloatLabelFormattedInput
      register={{ ...register(field) }}
      label={title}
      value={watch(field) || ""}
      type={type || "text"}
      error={error}
      pattern={pattern}
      disabled={disable}
      setValue={setValue}
      watch={watch}
    />
  );
};

export default UsePattern;
